namespace Ir.Components.Workbook.Settings.Items.ComparisonFilterSetting {
    export interface IComparisonFilterSettingParams {
        label?: string;
        labelInside?: boolean;
        manualText?: string;
        comparisonFilter: ComparisonFilter;
        isReportDesigner?: boolean;
        onComparisonDateOptionChanged?: (e: { value: ComparisonDateOptionEnum, previousValue: ComparisonDateOptionEnum }) => void;
        onValueChanged?: () => void;
        filterComparisonDateList?: (dateOption: ComparisonDateOptionEnum) => boolean;
    }
    interface IViewModel {
        label: string;
        labelInside: KnockoutObservable<boolean>;
        isReportDesigner: KnockoutObservable<boolean>;
        dxSelectBoxComparisonDateOption: DevExpress.ui.dxSelectBox.Properties;
        dxSelectBoxComparisonDateUnit: DevExpress.ui.dxSelectBox.Properties;
        dxNumberBoxComparisonDateUnitForDay: DevExpress.ui.dxNumberBox.Properties;
        comparisonDateUnitValueOptions: DevExpress.ui.dxSelectBox.Properties;
        dxSelectBoxDateRange: DevExpress.ui.dxLookup.Properties;
        predefinedCustomDateRangeBoxConfig: DevExpress.ui.dxDateRangeBox.Properties;
        predefinedCustomDateVisible: KnockoutComputed<boolean>;
    }

    interface IParams {
        config: IComparisonFilterSettingParams;
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        self.label = params.config.label;
        self.labelInside = ko.observable(params.config.labelInside ? true : false);
        self.isReportDesigner = ko.observable(params.config.isReportDesigner ? true : false);

        let comparisonFilter = params.config.comparisonFilter;

        let comparisonDateList = [
            { value: ComparisonDateOptionEnum.Manual, text: params.config.manualText ?? "Manual" },
            { value: ComparisonDateOptionEnum.Previous, text: "Previous" },
            { value: ComparisonDateOptionEnum.Predefined, text: "Predefined" },
        ];

        if (params.config.filterComparisonDateList) {
            comparisonDateList = comparisonDateList.filter(x => params.config.filterComparisonDateList(x.value));
        }

        let dateRangeList = DateRangeService.DatesRange;

        self.dxSelectBoxDateRange = {
            items: dateRangeList,
            displayExpr: "initials",
            valueExpr: "id",
            value: comparisonFilter.dateRange,
            width: 86,
            dropDownOptions: {
                title: "Date Range",
                width: 250,
                hideOnOutsideClick: true,
                showTitle: true,
            },
            showCancelButton: true,
            itemTemplate: function (data: DateRange, index, element) {
                return data.initials() + " - " + data.name();

                //const $item = $("<div>").text(
                //    index + " - " + data.itemProperty
                //);
                //element.append($item);
            },
            visible: ko.computed(function () {
                return comparisonFilter.dateOption() === ComparisonDateOptionEnum.Predefined;
            }) as any,
            onValueChanged(e) {
                params.config.onValueChanged?.();
            }
        };


        self.dxSelectBoxComparisonDateOption = {
            items: comparisonDateList,
            displayExpr: "text",
            valueExpr: "value",
            value: comparisonFilter.dateOption,
            width: 90,
            onValueChanged(e) {
                params.config.onComparisonDateOptionChanged?.({ value: e.value, previousValue: e.previousValue });
                params.config.onValueChanged?.();
            },
        };

        let comparisonDateUnitOptions = [
            { value: ComparisonDateUnitEnum.Year, text: "Year" },
            { value: ComparisonDateUnitEnum.Quarter, text: "Quarter" },
            { value: ComparisonDateUnitEnum.Month, text: "Month" },
            //{ value: "Week", text: "Week" },
            { value: ComparisonDateUnitEnum.Day, text: "Day" },
        ];

        self.dxSelectBoxComparisonDateUnit = {
            items: comparisonDateUnitOptions,
            displayExpr: "text",
            valueExpr: "value",
            value: comparisonFilter.dateUnit,
            width: 75,
            onSelectionChanged(e) {
                if (e.selectedItem?.value !== ComparisonDateUnitEnum.Day && comparisonFilter.dateUnitValue() > 12) {
                    //Other options have a select box that goes only until 12
                    comparisonFilter.dateUnitValue(1);
                }
            },
            onValueChanged(e) {
                params.config.onValueChanged?.();
            },
            visible: ko.computed(function () {
                return comparisonFilter.dateOption() === ComparisonDateOptionEnum.Previous;
            }) as any,
        };

        let comparisonDateUnitValueList = [
            { value: 1 },
            { value: 2 },
            { value: 3 },
            { value: 4 },
            { value: 5 },
            { value: 6 },
            { value: 7 },
            { value: 8 },
            { value: 9 },
            { value: 10 },
            { value: 11 },
            { value: 12 },
        ];

        self.dxNumberBoxComparisonDateUnitForDay = {
            min: 1,
            max: 999,
            showSpinButtons: isMobile() ? false : true,
            format: '#',
            value: comparisonFilter.dateUnitValue as any,
            width: 51,
            visible: ko.computed(function () {
                return comparisonFilter.dateOption() === ComparisonDateOptionEnum.Previous && comparisonFilter.dateUnit() === ComparisonDateUnitEnum.Day;
            }) as any,
            onValueChanged(e) {
                params.config.onValueChanged?.();
            }
        };

        self.comparisonDateUnitValueOptions = {
            items: comparisonDateUnitValueList,
            displayExpr: "value",
            valueExpr: "value",
            value: comparisonFilter.dateUnitValue,
            width: 51,
            visible: ko.computed(function () {
                return comparisonFilter.dateOption() === ComparisonDateOptionEnum.Previous && comparisonFilter.dateUnit() !== ComparisonDateUnitEnum.Day;
            }) as any,
            onValueChanged(e) {
                params.config.onValueChanged?.();
            }
        };

        self.predefinedCustomDateVisible = ko.computed(() => {
            let visible = comparisonFilter.dateOption() === ComparisonDateOptionEnum.Predefined && comparisonFilter.dateRange() === irGlobal.customDate.custom;
            if (visible) {
                if (!comparisonFilter.predefinedCustomDate()) {
                    let todayDateRange = DateRangeService.DatesRange.find(x => x.id() === irGlobal.customDate.today);
                    let startDate = todayDateRange.startDate();
                    let endDate = todayDateRange.endDate();
                    comparisonFilter.predefinedCustomDate(`${startDate};${endDate}`);
                }
            }
            else {
                comparisonFilter.predefinedCustomDate("");
            }

            return visible;
        });

        let predefinedCustomDateRange = ko.observableArray([null, null]);
        let predefinedCustomDateRangeObs = ko.computed(() => {
            let date = comparisonFilter.predefinedCustomDate();
            if (date) {
                let dates = date.split(";");
                predefinedCustomDateRange([dates[0], dates[1]]);
            }
            else {
                predefinedCustomDateRange([null, null]);
            }
        }) as any
        self.predefinedCustomDateRangeBoxConfig = {
            multiView: false,
            displayFormat: irSettings.shortDateFormat,
            width: 140,
            value: predefinedCustomDateRange as any,
            labelMode: "hidden",
            showClearButton: false,
            openOnFieldClick: true,
            showDropDownButton: false,
            startDateInputAttr: { onfocus: "this.select()" },
            endDateInputAttr: { onfocus: "this.select()" },
            onFocusIn(e) {
                e.element.select();
            },
            onValueChanged(e) {
                if (comparisonFilter.dateOption() === ComparisonDateOptionEnum.Predefined && comparisonFilter.dateRange() === irGlobal.customDate.custom) {
                    let previousStartDate = e.previousValue[0];
                    let previousEndDate = e.previousValue[1];
                    let startDate = e.value[0];
                    let endDate = e.value[1];

                    if (previousStartDate !== startDate || previousEndDate !== endDate) {
                        if (typeof startDate === "object" && startDate) {
                            startDate = DevExpress.localization.formatDate(startDate, "yyyy-MM-dd")
                        }
                        if (typeof endDate === "object" && endDate) {
                            endDate = DevExpress.localization.formatDate(endDate, "yyyy-MM-dd")
                        }

                        if (!startDate || !endDate) {
                            let todayDateRange = DateRangeService.DatesRange.find(x => x.id() === irGlobal.customDate.today);
                            if (!startDate) {
                                startDate = todayDateRange.startDate();
                            }

                            if (!endDate) {
                                endDate = todayDateRange.endDate();
                            }
                        }

                        comparisonFilter.predefinedCustomDate(`${startDate};${endDate}`);
                        params.config.onValueChanged?.();
                    }
                }
            }
        };
    }
}